

export const InsurancePage = () => {
    return (
        <div className="Insurance Page">
            InsurancePage
        </div>
    )
}

export default InsurancePage